import React, { useEffect, useState } from "react";
import NavbarVisitor from "../Component/NavbarVisitor";
import { Link } from "react-router-dom";
import axios from "axios";
import { BASE_URL, IMAGE_URL } from "../Component/Baseurl";
import Footer from "../Component/Footer";  
import defaultImage from '../Component/img/event1.jfif'; 

const TopEvent = () => {
    const [events, setEvents] = useState([]); 
    const [loading, setLoading] = useState(true); 
    const [error, setError] = useState(null); 

    useEffect(() => {
      const fetchEvents = async () => {
        try {
          const response = await axios.get(`${BASE_URL}/fetchAllEvents`);
          if (response.data.success) {
            const eventList = response.data.events.slice(0, 8); 
            setEvents(eventList);
          } else {
            setError('Failed to fetch events');
          }
          setLoading(false); 
        } catch (error) {
          console.error('Error fetching events:', error);
          setError('Error fetching events');
          setLoading(false);
        }
      };
      fetchEvents();
    }, []);

    if (loading) {
      return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="ms-3">Loading Content...</p>
        </div>
      );
    }

    if (error) return <p>{error}</p>;

    return (
      <>
        <NavbarVisitor />

        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="row mt-3">
                <div className="col">
                  <h2 className="text-start hedng">Top Events</h2>
                </div>
              </div>

              <div className="row">
                {events.map((event) => (
                  <div key={event.id} className="col-md-3 mb-4">
                    <Link to={`/event/${event.event_slug}`} className="event-card-link">
                      <div className="event-card">
                        <img
                          src={event.event_image ? `${IMAGE_URL}${event.event_image}` : defaultImage} 
                          alt={event.name}
                          className="img-fluid eventimg"
                        />
                        <div className="event-details text-start p-1">
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <span className="badge bg-gradient-primary etype">
                              {event.event_type} | {event.event_mode}
                            </span>
                            <span className="ft-tags">
                              {new Date(event.event_start_date).toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: 'short',
                                year: '2-digit',
                              })}
                            </span>
                          </div>
                          <h4 className="ft-event">{event.event_name}</h4>
                          <div>
                            <span className="ft-tags">
                              {event.event_industry.split(',').map((industry, index) => (
                                <React.Fragment key={index}>
                                  #{industry.trim()}
                                  {index < event.event_industry.split(',').length - 1 && ' '}
                                </React.Fragment>
                              ))}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </>
    );
};

export default TopEvent;
